import {
  InutilizacaoRequest,
  InutilizacaoResponse,
  ConsultaRequest,
  ConsultaResponse,
  HealthResponse,
  ConsultaPeriodoRequest,
  ConsultaPeriodoResponse,
  StoreData
} from '@/@types/migrate';
import { Tags } from '@/enum/tags';
import { apiSlice } from './http';

export const migrateService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    processarInutilizacao: builder.mutation<InutilizacaoResponse, InutilizacaoRequest>({
      query: (data) => ({
        url: 'migrate/inutilizacao',
        method: 'POST',
        body: data,
        timeout: 300000, // 5 minutos para operações longas
      }),
      invalidatesTags: [Tags.TAX_DASHBOARD],
    }),

    consultarPorPeriodo: builder.mutation<ConsultaPeriodoResponse, ConsultaPeriodoRequest>({
      query: (data) => ({
        url: 'migrate/consulta/periodo',
        method: 'POST',
        body: data,
        timeout: 300000, // 5 minutos para operações longas
      }),
      invalidatesTags: [Tags.TAX_DASHBOARD],
    }),
    
    consultarDocumento: builder.query<ConsultaResponse, ConsultaRequest>({
      query: ({ cnpj, serie, numero, maxTentativas }) => {
        const params = new URLSearchParams();
        
        params.append('cnpj', cnpj);
        params.append('serie', serie);
        params.append('numero', numero.toString());
        if (maxTentativas) params.append('maxTentativas', maxTentativas.toString());

        return {
          url: `migrate/consulta?${params.toString()}`,
          method: 'GET',
        };
      },
      providesTags: [Tags.TAX_DASHBOARD],
    }),
    
    listarLojas: builder.query<StoreData[], void>({
      query: () => ({
        url: 'migrate/lojas',
        method: 'GET',
      }),
      providesTags: [Tags.TAX_DASHBOARD],
    }),

    verificarSaude: builder.query<HealthResponse, void>({
      query: () => ({
        url: 'migrate/health',
        method: 'GET',
      }),
      providesTags: [Tags.TAX_DASHBOARD],
    }),
    
    executarTesteInutilizacao: builder.mutation<InutilizacaoResponse, void>({
      query: () => ({
        url: 'migrate/inutilizacao/teste',
        method: 'POST',
      }),
      invalidatesTags: [Tags.TAX_DASHBOARD],
    }),
  }),
});

export const {
  useProcessarInutilizacaoMutation,
  useLazyConsultarDocumentoQuery,
  useListarLojasQuery,
  useLazyVerificarSaudeQuery,
  useExecutarTesteInutilizacaoMutation,
  useConsultarPorPeriodoMutation,
} = migrateService; 